import React from 'react';
import { FormattedMessage } from 'react-intl';
import { StyledButton } from './ChangePasswordForm.styles';

const ChangePasswordFormSuccess = () => (
  <>
    <FormattedMessage id="changePassword.success" />
    <StyledButton href="/">
      <FormattedMessage id="changePassword.proceed" />
    </StyledButton>
  </>
);

export default ChangePasswordFormSuccess;
